import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ManageDashboardRoutingModule } from '@flyfreely-portal-ui/manage-dashboard';
import { FEATURE_SAFETY_MANAGEMENT } from '@flyfreely-portal-ui/flyfreely';
import {
    IncidentsRoutingModule,
    SafetyRoutingModule
} from '@flyfreely-portal-ui/safety-assessment';
import { FeatureFlagGuard } from 'libs/ui/src/lib/router-guards/featureFlag.guard';
import { MissionViewRoutingModule } from '@flyfreely-portal-ui/mission-view';
import { OutstandingTasksRoutingModule } from '@flyfreely-portal-ui/outstanding-tasks';
import { ReportingRoutingModule } from '@flyfreely-portal-ui/reporting';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: 'home',
                loadChildren: () => ManageDashboardRoutingModule,
                data: {
                    enhancedHelpComponentIdentifier: 'manage-dashboard',
                    routeNodeType: 'dashboard'
                }
            },
            {
                path: 'missions',
                loadChildren: () => MissionViewRoutingModule,
                data: {
                    enhancedHelpComponentIdentifier: 'missions-dashboard',
                    routeNodeType: 'dashboard'
                }
            },
            {
                path: 'reporting',
                loadChildren: () => ReportingRoutingModule,
                data: {
                    enhancedHelpComponentIdentifier: 'reporting-dashboard',
                    routeNodeType: 'dashboard'
                }
            },
            {
                path: 'tasks',
                loadChildren: () => OutstandingTasksRoutingModule,
                data: {
                    enhancedHelpComponentIdentifier: 'tasks-dashboard',
                    routeNodeType: 'dashboard'
                }
            },
            {
                // Must stay before 'safety' so the incidents screens match first
                path: 'safety/incidents',
                loadChildren: () => IncidentsRoutingModule,
                canActivate: [FeatureFlagGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    requiredFeatureFlag: FEATURE_SAFETY_MANAGEMENT,
                    enhancedHelpComponentIdentifier: 'safety-incidents',
                    routeNodeType: 'dashboard'
                }
            },
            {
                path: 'safety',
                loadChildren: () => SafetyRoutingModule,
                canActivate: [FeatureFlagGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    requiredFeatureFlag: FEATURE_SAFETY_MANAGEMENT,
                    enhancedHelpComponentIdentifier: 'safety-dashboard',
                    routeNodeType: 'dashboard'
                }
            }
        ])
    ],
    exports: [RouterModule]
})
export class WorkspaceRoutingModule {}
